import { render, staticRenderFns } from "./excel-column-select.vue?vue&type=template&id=0d0acdd1&"
import script from "./excel-column-select.vue?vue&type=script&lang=ts&"
export * from "./excel-column-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0acdd1')) {
      api.createRecord('0d0acdd1', component.options)
    } else {
      api.reload('0d0acdd1', component.options)
    }
    module.hot.accept("./excel-column-select.vue?vue&type=template&id=0d0acdd1&", function () {
      api.rerender('0d0acdd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/companies/components/excel-column-select.vue"
export default component.exports